// admin/Dashboard/Hero1.jsx
import React, { useEffect, useState, useMemo } from 'react';
import Classes from '../Dashboard.module.css';
import { CalenderIcon, DollarIcon, FileIcon, ProfileIcon } from '../../../../../../utils/Icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import backend from '../../../../../../api';

function money(n = 0, c = 'USD') {
  const v = Number(n || 0);
  return v.toLocaleString(undefined, { style: 'currency', currency: c.toUpperCase() });
}

export default function Hero1() {
  const navigateTo = useNavigate();
  const onboarding = useSelector((state) => state.companyInfo.info);
  const companyId = onboarding?._id;

  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    revenue: 0,
    currency: 'usd',
    clients: { total: 0 },
    appointments: { total: 0 },
    invoices: { total: 0, paid: 0, pending: 0, overdue: 0 },
  });

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!companyId) return;
      try {
        setLoading(true);
        const { data } = await backend.get(`/api/admin/stats`, { params: { companyId } });
        if (alive && data?.ok) setStats(data);
      } catch (e) {
        console.error('Fetch admin stats error:', e);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [companyId]);

  const revenueLabel = useMemo(() => money(stats.revenue, stats.currency), [stats.revenue, stats.currency]);

  return (
    <>
      <div className={Classes.hero1}>
        <div className={Classes.heroBox}>
          <div className={Classes.hero1Img}>
            <DollarIcon height='27px' width='27px' fill='white' />
          </div>
          <div>
            <h5 className={Classes.title1}>Revenue</h5>
            <h3>{loading ? '$0' : revenueLabel}</h3>
          </div>
        </div>

        <div className={Classes.miniLine}></div>

        <div className={Classes.heroBox}>
          <div className={Classes.hero1Img}>
            <ProfileIcon height='27px' width='27px' fill='white' />
          </div>
          <div>
            <h5 className={Classes.title1}>Clients</h5>
            <h3 className='pointer' onClick={() => { navigateTo('/clients') }}>
              {loading ? '0' : stats?.clients?.total ?? 0} <span>{'>'}</span>
            </h3>
          </div>
        </div>

        <div className={Classes.miniLine}></div>

        <div className={Classes.heroBox}>
          <div className={Classes.hero1Img}>
            <CalenderIcon height='27px' width='27px' fill='white' />
          </div>
          <div>
            <h5 className={Classes.title1}>Appointments</h5>
            <h3 className='pointer' onClick={() => { navigateTo('/appointments') }}>
              {loading ? '0' : stats?.appointments?.total ?? 0} <span>{'>'}</span>
            </h3>
          </div>
        </div>

        <div className={Classes.miniLine}></div>

        <div className={Classes.heroBox}>
          <div className={Classes.hero1Img}>
            <FileIcon height='27px' width='27px' fill='white' />
          </div>
          <div>
            <h5 className={Classes.title1}>Invoices</h5>
            <div className={Classes.flexAlign5}>
              <h3 className='pointer' onClick={() => { navigateTo('/invoices') }}>
                {loading ? '0' : stats?.invoices?.total ?? 0} <span>{'>'}</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
